import * as React from "react";
export const ParametroBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
